import React, { useEffect, useState, Fragment } from "react";
import { Link } from "react-router-dom";
import CardLimit from "../cardholderCardScreens/CardLimits";
import tickRound from "../../assets/images/tick-round.svg";
import eyeOn from "../../assets/images/eye-on.svg";
import wifiSignalCard from "../../assets/images/wifi-signal.svg";

const THEME_FIELDS = [
  { key: "mainBg", cssVar: "--color-main-bg", label: "Main Background" },
  { key: "menuBg", cssVar: "--color-menu-bg", label: "Menu Background" },
  { key: "cardBg", cssVar: "--color-card-bg", label: "Card Background" },
  { key: "selectedTab", cssVar: "--color-selected-tab", label: "Selected Tab" },
  { key: "tabHover", cssVar: "--color-tab-hover", label: "Tab Hover" },
  { key: "headingText", cssVar: "--color-heading-text", label: "Heading Text" },
  { key: "icon", cssVar: "--color-icon", label: "Icon Color" },
  { key: "line", cssVar: "--color-line", label: "Line Color" },
  { key: "textBox", cssVar: "--color-text-box", label: "Text Box Color" },
  { key: "font", cssVar: "--color-font", label: "Font Color" },
];

const readInitialTheme = () => {
  const params = new URLSearchParams(window.location.search);
  return THEME_FIELDS.reduce((acc, { key }) => {
    const raw = params.get(key);
    acc[key] = raw ? "#" + raw.replace(/^#/, "") : "";
    return acc;
  }, {});
};

const isValidHex = (value) => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value);

const PreviewTheme = props => {
  const [activeClass, setActiveClass] = useState("dashboard");
  const [theme, setTheme] = useState(readInitialTheme);

  const applyActiveClass = id => {
    setActiveClass(id);
  };

  useEffect(() => {
    THEME_FIELDS.forEach(({ key, cssVar }) => {
      const value = theme[key];
      if (isValidHex(value)) {
        document.documentElement.style.setProperty(cssVar, value);
      }
    });
  }, [theme]);

  useEffect(() => {
    return () => {
      THEME_FIELDS.forEach(({ cssVar }) => {
        document.documentElement.style.removeProperty(cssVar);
      });
    };
  }, []);

  const handleColorChange = (key, value) => {
    setTheme((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="bo-app-main">
      <header className="header-main-outer">
        <section className="header-main">
          <div className="row align-items-center position-relative position-md-static">
            <div className="col-12 p-static d-flex align-items-center justify-content-center">
              <div className="div-hamburger">
                <button className="hamburgers" type="button">
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
              <div className="logo d-flex align-items-center bo-thumb">
                <Link to="#">
                  <h3>
                    Card<span>Console</span>
                  </h3>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </header>

      <div
        style={{
          padding: "1.2rem 2rem",
          background: "#ffffff",
          borderBottom: "1px solid #e0dcdc",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <div
          style={{
            fontSize: "1.3rem",
            fontWeight: 600,
            color: "#161618",
            marginBottom: "0.8rem",
          }}
        >
          White-Label Colors &mdash; edit any value to preview live below
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
            gap: "0.8rem",
          }}
        >
          {THEME_FIELDS.map(({ key, label }) => {
            const value = theme[key];
            const pickerValue = isValidHex(value) ? value : "#000000";
            return (
              <div
                key={key}
                style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}
              >
                <input
                  type="color"
                  aria-label={label}
                  value={pickerValue}
                  onChange={(e) => handleColorChange(key, e.target.value)}
                  style={{
                    width: "2.8rem",
                    height: "2.8rem",
                    padding: 0,
                    border: "1px solid #cccccc",
                    borderRadius: "0.4rem",
                    background: "transparent",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                />
                <div style={{ fontSize: "1.1rem", lineHeight: 1.2, flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#161618",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {label}
                  </div>
                  <input
                    type="text"
                    value={value}
                    placeholder="#000000"
                    maxLength={7}
                    onChange={(e) => {
                      let next = e.target.value.trim();
                      if (next && !next.startsWith("#")) next = "#" + next;
                      handleColorChange(key, next);
                    }}
                    style={{
                      width: "100%",
                      padding: "0.2rem 0.4rem",
                      border: "1px solid #cccccc",
                      borderRadius: "0.3rem",
                      fontSize: "1.1rem",
                      color: "#666",
                      fontFamily: "monospace",
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="row minh-row">
        <div className="col-lg-3 col-md-0 bo-sidebar-col" id="leftNav">
          <div className="bo-sidebar-outer">
            <Link
              to="/dashboard"
              className={
                activeClass === "dashboard" || activeClass === ""
                  ? "active"
                  : ""
              }
              onClick={() => applyActiveClass("dashboard")}
            >
              <div className="logo d-flex align-items-center bo-thumb">
                <Link to="#">
                  <h3>
                    Card<span>Console</span>
                  </h3>
                </Link>
              </div>
            </Link>
            <ul className="sidebar-ul">
              <li>
                <Link
                  className={activeClass === "dashboard" ? "active" : ""}
                  onClick={() => applyActiveClass("dashboard")}
                >
                  <i className="icon-dashboard"></i>Dashboard
                </Link>
              </li>
              <li>
                <Link
                  className={activeClass === "cards" ? "active" : ""}
                  onClick={() => applyActiveClass("cards")}
                >
                  <i className="icon-card"></i>My Cards
                </Link>
              </li>
              <li>
                <Link
                  className={activeClass === "cardholdertransactions" ? "active" : ""}
                  onClick={() => applyActiveClass("cardholdertransactions")}
                >
                  <i className="icon-transaction"></i>Transactions
                </Link>
              </li>
              <li>
                <Link
                  className={activeClass === "settings" ? "active" : ""}
                  onClick={() => applyActiveClass("settings")}
                >
                  <i className="icon-settings"></i>Settings
                </Link>
              </li>
              <li>
                <Link
                  className={activeClass === "help" ? "active" : ""}
                  onClick={() => applyActiveClass("help")}
                >
                  <i className="icon-help"></i>Help
                </Link>
              </li>

              <hr />
              <li>
                <Link className="d-flex align-items-center logout">
                  <i className="icon-logout"></i>
                  <span>
                    <span>Logout</span>
                    <br />
                    <span className="user-name">preview theme</span>
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-xl-6 col-lg-8 col-md-12 bo-main-content">
          <h3>
            Your Cards<span className="bo-badge bo-badge-large">1</span>
          </h3>
          <div className="row mt-20">
            <div className="col-xl-6 col-md-6 col-sm-6 mb-20">
              <div className="text-center">
                <Fragment>
                  <div className="bo-credit-card">
                    <div class="card-bgs">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="bo-credit-card-inner">
                      <div className="d-flex align-items-center top-bar">
                        <div className="top-bar-left">
                          <span></span>
                        </div>
                        <div className="top-bar-right ml-auto dull-label">
                          <span>Virtual Card</span>
                          <img className="ml-1" src={wifiSignalCard} />
                        </div>
                      </div>
                      <div className="account-balance mb-20">
                        <h1>
                          {"19"} {"USD"}
                        </h1>
                      </div>
                      <div className="d-flex mb-2">
                        <div className="card-no d-flex">
                          <span>{"5240-13XX-XXXX-9819"}</span>
                        </div>
                        <div className="ml-auto">
                          <span className="black-circle d-flex align-items-center justify-content-center">
                            <img src={eyeOn} />
                          </span>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="label-plus-value dull-label">
                          <span>Valid Thru</span>
                          <p>{"07/28"}</p>
                        </div>
                        <div className="label-plus-value dull-label">
                          <span>Token ID</span>
                          <p>{"2940697109"}</p>
                        </div>
                        <div className="label-plus-value dull-label">
                          <span>Currency</span>
                          <p>{"USD"}</p>
                        </div>
                        <div className="label-plus-value dull-label">
                          <span>Status</span>
                          <p>
                            <img src={tickRound} />
                            Active
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fragment>
              </div>
            </div>
            <CardLimit />
          </div>
          <Fragment>
            <div className="row align-items-center mt-14">
              <div className="col-6">
                <h3> Overall Transactions</h3>
              </div>
              <div className="col-6 text-end">
                <button type="button" className="btn btn-outline">
                  Export To Excel
                </button>
              </div>
            </div>
            <div className="mt-0 mt-sm-4">
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="allClients"
                  role="tabpanel"
                  aria-labelledby="allClients-tab"
                >
                  {/* no client found  */}
                  <div className="d-flex align-content-center justify-content-center no-clients-msg d-none">
                    <div className="text-center">
                      <span className="icon-clients-empty">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                        <span className="path5"></span>
                        <span className="path6"></span>
                      </span>
                      <h3>Empty Clients Listing</h3>
                      <h6>There is no Client(s) available for now.</h6>
                    </div>
                  </div>
                </div>

                <div className="table-wrap">
                  <table className="table table-borderless bo-table table-cards">
                    <thead>
                      <th>DATE</th>
                      <th>MERCHANT NAME</th>
                      <th>STATUS</th>
                      <th>AMOUNT</th>
                      <th>VIEW</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>JUNE 3, 2026</td>
                        <td>DEBIT CARD</td>
                        <td>SUCCESS</td>
                        <td>1 USD</td>
                        <td><span className="icon-show"></span></td>
                      </tr>
                      <tr>
                        <td>JUNE 3, 2026</td>
                        <td>DEBIT CARD</td>
                        <td>SUCCESS</td>
                        <td>2 USD</td>
                        <td><span className="icon-show"></span></td>
                      </tr>
                      <tr>
                        <td>JUNE 3, 2026</td>
                        <td>TOP UP</td>
                        <td>SUCCESS</td>
                        <td>20 USD</td>
                        <td><span className="icon-show"></span></td>
                      </tr>
                      <tr>
                        <td>JUNE 2, 2026</td>
                        <td>TOP UP</td>
                        <td>SUCCESS</td>
                        <td>1 USD</td>
                        <td><span className="icon-show"></span></td>
                      </tr>
                      <tr>
                        <td>JUNE 2, 2026</td>
                        <td>CREATE</td>
                        <td>SUCCESS</td>
                        <td>1 USD</td>
                        <td><span className="icon-show"></span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Fragment>
        </div>
        <div className="col-xl-3 col-lg-4 col-lg-0 bo-right-sidebar">
          <div className="bo-right-sidebar-wrap">
            <h3>Card Details</h3>
            <ul className="ul-card-details-popup mt-16 mb-5">
              <li className="d-flex justify-content-between mb-20">
                <span>Balance</span>
                <b>19 USD</b>
              </li>
              <li className="d-flex justify-content-between mb-20">
                <span>Token ID</span>
                <b>2940697109</b>
              </li>
              <li className="d-flex justify-content-between mb-20">
                <span>Valid Thru</span>
                <b>07/28</b>
              </li>
              <li className="d-flex justify-content-between mb-20">
                <span>Card Type</span>
                <b>Virtual</b>
              </li>
              <li className="d-flex justify-content-between mb-20">
                <span>Status</span>
                <b>Active</b>
              </li>
              <li className="d-flex justify-content-between mb-20">
                <span>CVV</span>
                <span className="d-flex align-items-center">
                  <img src={eyeOn} style={{ marginRight: "0.6rem" }} />
                  <b>***</b>
                </span>
              </li>
            </ul>
            <div className="form-group submit-field mt-20">
              <button
                type="button"
                className="btn btn-large w-100"
                style={{ backgroundColor: "#2ea44f" }}
              >
                UNLOCKED
              </button>
            </div>
            <div className="mt-40">
              <h3>Help</h3>
              <p className="mt-16" style={{ fontSize: "1.2rem" }}>
                For further queries Admin will reach out via email if more details
                are required we will contact you.
              </p>
              <Link to="#" className="mt-16 d-inline-block">
                Submit Your Query &rsaquo;
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewTheme;
